import { generateUID } from "@/canv/utils";
import type { TextWidgetV2 } from "@/elements/text/textV2";

export const regenerateTextPartUID = (textPart: TextWidgetV2, parentUID = "") => {
    textPart.UID = generateUID();
    textPart.parentUID = parentUID;
    textPart.trailUID = "";

    textPart.regenerateUIDS();
};
